module.exports = __webpack_public_path__ + "img/z-solution-img1.6cb282dd.png";